import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { CheckSubscriptionExpiration } from '../services/check-subscription-expiration.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionExpirationGuard implements CanActivate {
  constructor(private checkSubscriptionExpiration: CheckSubscriptionExpiration) {}
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    this.checkSubscriptionExpiration.isSubscriptionExpired();
    return true;
  }
}
